/**
 * TEMPORARY: Utility to access feature toggles directly from window's preloaded state.
 * This is mimicking similar code from configuration context and in this case
 * is needed for code that runs at module load time before Redux store selectors are available
 * (e.g., Sentry setup in root.js).
 *
 * TODO (HERMES): During HERMES migration, we will move these setup (sentry,service worker, error boundary) to server side and read toggle there
 */

// Read once from window and cache the value
export const generalToggles = window.__PRELOADED_STATE__?.featureToggles?.generalToggles ?? {};
